import { render, staticRenderFns } from "./ValidUsers.vue?vue&type=template&id=19bfafcc&scoped=true&"
import script from "./ValidUsers.vue?vue&type=script&lang=js&"
export * from "./ValidUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfafcc",
  null
  
)

export default component.exports